import React, { useState } from 'react';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import DetailsCard from '../../subscription/details/components/DetailsCard';
import CustomButton from '../../../components/buttons/CustomButton';
import { referralLink, referralShareMessage } from '../referralStatus';
import styles from '../Referral.module.css';

/**
 * Como funciona, o link pessoal e os botões de copiar e mandar pelo WhatsApp.
 * @param {Object} props
 * @param {string|null} props.code
 * @param {boolean} props.loading
 */
function ReferralLinkCard({ code, loading }) {
  const [copied, setCopied] = useState(false);
  const link = code ? referralLink(code) : '';

  const handleCopy = () => {
    if (!link) return;
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  const handleWhatsApp = () => {
    if (!code) return;
    window.open(`https://wa.me/?text=${encodeURIComponent(referralShareMessage(code))}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <DetailsCard title="Seu link de indicação" subtitle="Quem entrar por ele já chega com o seu nome no cadastro.">
      <div className={styles.steps}>
        <div className={styles.step}>
          <span className={styles.stepNumber}>1</span>
          <p className={styles.stepTitle}>Compartilhe</p>
          <p className={styles.stepText}>Mande o seu link para um colega ou indique direto pelo nome e WhatsApp.</p>
        </div>
        <div className={styles.step}>
          <span className={styles.stepNumber}>2</span>
          <p className={styles.stepTitle}>A pessoa testa</p>
          <p className={styles.stepText}>Ela cria a conta e usa a Gabriela por 30 dias sem pagar nada.</p>
        </div>
        <div className={styles.step}>
          <span className={styles.stepNumber}>3</span>
          <p className={styles.stepTitle}>Você ganha</p>
          <p className={styles.stepText}>Quando ela assina, você recebe um mês do seu plano de crédito na próxima fatura.</p>
        </div>
      </div>

      <div className={styles.linkBox}>
        <span className={styles.linkText}>{loading ? 'Carregando seu link...' : link}</span>
      </div>

      <div className={styles.actions}>
        <CustomButton
          style="primary"
          variant="contained"
          label={copied ? 'Link copiado' : 'Copiar link'}
          icon={copied ? <CheckRoundedIcon fontSize="small" /> : <ContentCopyOutlinedIcon fontSize="small" />}
          enabled={!!code}
          onClick={handleCopy}
        />
        <CustomButton
          style="primary"
          variant="outlined"
          label="Mandar pelo WhatsApp"
          icon={<WhatsAppIcon fontSize="small" />}
          enabled={!!code}
          onClick={handleWhatsApp}
        />
      </div>

      <p className={styles.rule}>
        Em teste? O crédito fica guardado e entra quando você assinar. O crédito vale por 90 dias
        e não é convertido em dinheiro. Quem você indica não ganha desconto: recebe o teste
        completo e um contato pessoal da equipe da Gabriela.
      </p>
    </DetailsCard>
  );
}

export default ReferralLinkCard;
